import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import { useLocation } from "react-router-dom"
import Button from "../../../../../components/Button"
import Dropdown from "../../../../../components/DropDown"
import InputField from "../../../../../components/InputField"
import { addNewPayment, getCenterDetails, getPaymentModeDetails } from "../../../../../core/services/api"
import "./AddNewPayment.scss"


function AddNewPayment({ onPaymentCancel, editData }: any) {
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const [isSubmit, setIsSubmit] = useState(false)
  const [resData, setResData] = useState([])
  const [formErrors, setFormErrors] = useState<any>()
  // const editData = location?.state?.editData
  const [currentData, setCurrentData] = useState<any>()

  const [paymentInfo, setPaymentInfo] = useState<any>({
    paymentMode: "",
    feePercentage: "",
    type: ""
  })

  const handleSubmit = (e: any) => {
    e.preventDefault()
    setFormErrors(validate(paymentInfo))
    setIsSubmit(true)
  }


  const validate = (values: any) => {
    const errors: any = {}
    if (!values.paymentMode) {
      errors["paymentMode"] = "Name is required"
    }

    return errors
  }
  useEffect(() => {
    getPaymentModeDetails(userDetail?.currentCenter?.centerId)
      .then((res) => {
        setCurrentData(res)
      })
      .catch((err) => {
        console.log('err', err)
      })
    if (editData) {
      setPaymentInfo({
        paymentMode: editData.paymentMode,
        feePercentage: editData.feePercentage,
        type: editData.type
      })
    }
  }, [])

  useEffect(() => {
    if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
      let paymentDetails = {
        paymentMode: paymentInfo.paymentMode,
        type: paymentInfo.type,
        feePercentage: parseInt(paymentInfo.feePercentage)
      }


      let finalReq = [];

      if (Object.keys(editData).length > 0) {

        const find = currentData?.findIndex((eachData: any) => eachData.id === editData?.id);


        let clone = [...currentData]
        clone[find] = paymentDetails;


        finalReq = clone
      }
      else {
        finalReq = currentData.concat(paymentDetails)
      }


      addNewPayment(centerId, finalReq)
        .then((data) => {
          setResData(data)
          onPaymentCancel()

        })
        .catch((err) => {
          console.log(err)
        })
    }

  }, [formErrors])

  const [centerDetail, setCenterDetail] = useState<any>()
  useEffect(() => {
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })

  }, [])

  const [centerId, setCenterId] = useState<any>()
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })
  return (
    <div className="add-new-payment-container">
      <div className="add-new-payment-details">
        <form onSubmit={handleSubmit}>
          <div className="add-new-payment-heading" style={{ display: 'flex', alignItems: 'center' }}>
            <div
              className="billing-back-image"
              onClick={() => {
                onPaymentCancel(true)
              }}
            >
              <img
                src={'../../../assets/images/back-icon.svg'}
                height={'60px'}
                width={'60px'}
                alt="back button"
              />
            </div>
            Add New Mode of Payment</div>
          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">Mode of Payment:</label>
            </div>

            <div className="col-3">
              <InputField
                placeholder="Payment Mode"
                value={paymentInfo?.paymentMode}
                handleChange={(e) => {
                  console.log(e.target.value, "Payment Mode");
                  setPaymentInfo({ ...paymentInfo, paymentMode: e.target.value });
                }}
                type="text"
              />
            </div>
          </div>

          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">Location:</label>
            </div>
            <div className="col-3">
              <Dropdown
                selected={centerId}
                updateDropdown={(option: any) => {
                  setCenterId(option);
                }}
                placeholder="Location"
                options={dropdownCenters}
              />
            </div>
          </div>


          <div className="button-alignment">
            <div>
              <Button
                text="Cancel"
                type={"button"}
                outline={true}
                // onClick={() => history.push(`/billing`)}
                onClick={() => onPaymentCancel()}
                id="cancel"
              />
            </div>
            <div>
              <Button text="Save" type="submit" id="save" />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
export default AddNewPayment
